import { apiCall } from '../../../../_services/apiCall';
import config from '../../../../config/config';


export const listReportRules = async () => {
  const response = await apiCall(
    `${config.POSTLOGIN_API_URL_COMPANY}iot-meters/report-rules`,
    {},
    {},
    'GET'
  );
  return response?.data || [];
};

export const getReportRule = async (reportRuleId) => {
  const response = await apiCall(
    `${config.POSTLOGIN_API_URL_COMPANY}iot-meters/report-rules/${reportRuleId}`,
    {},
    {},
    'GET'
  );
  return response?.data?.data;
};

export const createReportRule = async (data) => {
  const response = await apiCall(
    `${config.POSTLOGIN_API_URL_COMPANY}iot-meters/report-rules`,
    {},
    data,
    'POST'
  );
  return response?.data?.data;
};

export const updateReportRule = async (reportRuleId, data) => {
  const response = await apiCall(
    `${config.POSTLOGIN_API_URL_COMPANY}iot-meters/report-rules/${reportRuleId}`,
    {},
    data,
    'PUT'
  );
  return response?.data?.data;
};

export const deleteReportRule = async (reportRuleId) => {
  const response = await apiCall(
    `${config.POSTLOGIN_API_URL_COMPANY}iot-meters/report-rules/${reportRuleId}`,
    {},
    {},
    'DELETE'
  );
  return response?.data;
};